module.exports = __webpack_public_path__ + "static/media/metamask.5dee5511.svg";